import { render, staticRenderFns } from "./InsuranceResources.vue?vue&type=template&id=10247a51&"
import script from "./InsuranceResources.vue?vue&type=script&lang=js&"
export * from "./InsuranceResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports